export enum IdentityVerificationStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Failed = 'failed',
    Verified = 'verified',
}
